export class OriginSize {
    public static width: number = 1125;
    public static height: number = 2436;
}